// extracted by mini-css-extract-plugin
export default {"mobile":"_7pbw6","root":"kwJ6U","onImage":"-HYkv"};